const unslick = () => {
  $('.slick-initialized').slick('unslick');
};

export default {
  unslick,
};